export const MediaQueryEnum = {
    xs: {
        query: 'screen and (max-width: 575px)',
        minWidth: 0,
        breakpoint: 575
    },
    sm: {
        query: 'screen and (min-width: 576px)',
        minWidth: 576,
        breakpoint: 767
    },
    md: {
        query: 'screen and (min-width: 768px)',
        minWidth: 768,
        breakpoint: 991
    },
    lg: {
        query: 'screen and (min-width: 992px)',
        minWidth: 992,
        breakpoint: 1199
    },
    xl: {
        query: 'screen and (min-width: 1200px)',
        minWidth: 1200,
        breakpoint: 1599
    },
    xxl: {
        query: 'screen and (min-width: 1600px)',
        minWidth: 1600
    }
} as const;

